/**
 * AS3-faithful gem specs: stochastic damage range and fireRateMs per type.
 * Source: IngameCreator.as:200+ (damageMin, damageMax, firingSpeed).
 * fireRateMs = round(3333.33 / firingSpeed) — derived from AS3 "charge += dt*firingSpeed at 30fps".
 */

import type { GemType } from "./types.js";

export interface GemSpec {
  /** Min damage at grade 0 (level 1). Scales linearly with level. */
  damageMin: number;
  /** Max damage at grade 0 (level 1). Scales linearly with level. */
  damageMax: number;
  /** ms between shots when tower speed multiplier = 1. */
  fireRateMs: number;
  /** Tower range in cells (AS3 range px / ~33 px per cell). */
  rangeCells: number;
}

export const GEM_SPECS: Record<GemType, GemSpec> = {
  // MANA_GAIN: dmg 4-8, fs 1.8 → fr 1852, range 77px ≈ 2.3 cells
  Yellow: { damageMin: 4, damageMax: 8,  fireRateMs: 1852, rangeCells: 2.3 },
  // MULTIPLE_DAMAGE (splash): dmg 4-11, fs 2.0 → fr 1667, range 78px ≈ 2.4 cells
  Orange: { damageMin: 4, damageMax: 11, fireRateMs: 1667, rangeCells: 2.4 },
  // BLOODBOUND → our CRIT slot: dmg 4-13, fs 2.0 → fr 1667, range 80px ≈ 2.4 cells
  Red:    { damageMin: 4, damageMax: 13, fireRateMs: 1667, rangeCells: 2.4 },
  // SLOW: dmg 5-12, fs 2.1 → fr 1587, range 77px ≈ 2.3 cells
  Purple: { damageMin: 5, damageMax: 12, fireRateMs: 1587, rangeCells: 2.3 },
  // POISON: dmg 5-10, fs 2.1 → fr 1587, range 79px ≈ 2.4 cells
  Green:  { damageMin: 5, damageMax: 10, fireRateMs: 1587, rangeCells: 2.4 },
  // ARMOR_TEARING: dmg 3-11, fs 2.2 → fr 1515, range 73px ≈ 2.2 cells (shortest)
  Blue:   { damageMin: 3, damageMax: 11, fireRateMs: 1515, rangeCells: 2.2 },
  // SHOCK: dmg 4-10, fs 2.2 → fr 1515, range 75px ≈ 2.3 cells
  Cyan:   { damageMin: 4, damageMax: 10, fireRateMs: 1515, rangeCells: 2.3 },
  // CHAIN_HIT: dmg 6-10, fs 2.2 → fr 1515, range 78px ≈ 2.4 cells
  Lime:   { damageMin: 6, damageMax: 10, fireRateMs: 1515, rangeCells: 2.4 },
};

/** Default fire rate for empty tower (won't fire anyway — no gem). */
export const DEFAULT_FIRE_RATE_MS = 1667;
